import React, { useCallback, memo } from 'react';
import { Card, Icon, Tag, Typography, ButtonMenu } from '@ann/web-components';
import {
  CardWrapper,
  CardTop,
  CardHeader,
  CardHeaderTitle,
  CardMeta,
  CardMetaItem,
} from './Card.styled';

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

const DriveCard = ({ drive, onClick, onRemoveAccess }) => {
  const handleMenuChange = useCallback((value) => {
    if (value === 'remove-access') {
      onRemoveAccess?.(drive);
    } else if (value === 'view-details') {
      onClick?.(drive);
    }
  }, [drive, onClick, onRemoveAccess]);

  const handleCardClick = useCallback(() => {
    onClick?.(drive);
  }, [drive, onClick]);

  // Handler para detener propagación del click en el menu
  const handleMenuClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <Card>
      <CardWrapper onClick={handleCardClick}>
        <CardTop>
          <CardHeader>
            <Icon name="folder" size="medium" />
            <CardHeaderTitle title={drive.name}>
              <Typography 
                category="subtitle" 
                size="medium" 
                weight="bold" 
                color="title" 
                maxCharacters={30}
              >
                {drive.name || 'Unnamed Drive'}
              </Typography>
            </CardHeaderTitle>
            <div onClick={handleMenuClick}>
              <ButtonMenu
                customIcon="dotsMenu"
                disableEffects
                iconPosition="right"
                label=""
                menuPosition="bottom"
                onChange={handleMenuChange}
                size="medium"
                type="tertiary"
                width="260px"
              >
                <ButtonMenu.Menu>
                  <ButtonMenu.Item label="Remove access" value="remove-access" />
                  <ButtonMenu.Item label="View details" value="view-details" />                  
                </ButtonMenu.Menu>
              </ButtonMenu>
            </div>
          </CardHeader>

          <Typography category="body" size="medium" weight="regular" color="body">
            {drive.description || 'No description available'}
          </Typography>
        </CardTop>

        <CardMeta>
          <CardMetaItem>
            <Tag icon="person" size="medium" color="informative" />
            <Typography category="body" size="small" weight="regular" color="subtitle">
              {drive.owner || drive.createdBy || 'Unknown'}
            </Typography>
          </CardMetaItem>

          <CardMetaItem>
            <Tag icon="filePresent" size="medium" color="informative" />
            <Typography category="body" size="small" weight="regular" color="subtitle">
              {drive.documentCount || drive.files_count || 0} files
            </Typography>
          </CardMetaItem>

          <CardMetaItem>
            <Tag icon="calendarToday" size="medium" color="informative" />
            <Typography category="body" size="small" weight="regular" color="subtitle">
              {formatDate(drive.created_at || drive.createdAt)}
            </Typography>
          </CardMetaItem>
        </CardMeta>
      </CardWrapper>
    </Card>
  );
};

DriveCard.displayName = 'DriveCard';

export default memo(DriveCard);
